import { useParams } from "react-router-dom";
import { useFetchAthleteQuery } from "../../../store";
import FMSForm from "../../../components/fms/FMSForm";
import FMSTable from "../../../components/fms/FMSTable";

export default function FMSManager(){
  let { id } = useParams();
  const { data, error, isLoading} = useFetchAthleteQuery(id);
  let athlete;
  let content;
  if (isLoading) {
    content = <div> Loading...</div>;
    return content;
  }
  if (error) {
    content = <div> Error: {error.message}</div>;
    return content;
  }
  else{
    athlete = data[0];
    content = <div className="space-y-12">
      
      <div className="border-b border-gray-900/10 pb-12">
        <FMSTable athlete={athlete} />
      </div>
      <div className="pb-12">
        <FMSForm athlete={athlete} />
      </div>
    </div>
  }
  return (
    content
  )
}